<template>
  <div>
    <h4>Completed</h4>
    <p>Previously completed knowledge checks</p>

    <no-data v-if="noData" message="This knowledge check has not been completed."/>

    <b-table
      v-if="responses.length"
      ref="table"
      :hover="true"
      :responsive="true"
      :items="responses"
      :fields="tableFields"
      :no-local-sorting="false"
      @row-clicked="rowClicked">
      <template slot="completed_datetime" slot-scope="data">
        {{ readableDate(data.item.completed_date_time) }}
      </template>
      <template slot="correct" slot-scope="data">
        {{ data.item.correct_answers }}
      </template>
      <template slot="incorrect" slot-scope="data">
        {{ data.item.incorrect_answers }}
      </template>
      <template slot="score" slot-scope="data">
        {{ data.item.score }}
      </template>
      <template slot="empty">
        This knowledge check has not been completed.
      </template>
    </b-table>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import noData from '@/components/common/table/no-data'
import { readableDate } from '@/helpers'

export default {
  components:{
    noData
  },
  props:{
    items: {type:Array, required:true},
    responseView: { type: String, default: 'client-knowledgecheck-response-show' }
  },
  data(){
    return{
      tableFields:[
        {key: 'completed_datetime', label: 'Completed On'},
        {key: 'correct', label: 'Correct'},
        {key: 'incorrect', label: 'Incorrect'},
        {key: 'score', label: 'Score'}
      ]
    }
  },
  computed:{
    noData(){
      return this.items.length == 0
    },
    responses(){
      return _.sortBy(this.items, function(o){ return moment(o.completed_date_time).unix() }).reverse()
    }
  },
  methods:{
    readableDate,
    rowClicked(item){
      const routeParams = {
        knowledgecheckId: item.knowledge_check_id,
        responseId:item.id
      }

      this.$router.push({
        name: this.responseView,
        params: routeParams
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/client/knowledge-checks/completed-table.vue